import DatatableComponent from "../../../../components/common/DatatableComponent/DatatableComponent";
import HeaderOrange from "../../../../components/common/HeaderOrange/HeaderOrange";

const Commissions = () => {
  const data = [
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
    { category: "Health & Beauty", commission: "2.5" },
  ];

  const columns = [
    { name: "Category", selector: (row) => row.category, minWidth: "160px" },
    { name: "Commission", selector: (row) => row.commission, minWidth: "140px" },
  ];

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", padding: "20px" }}>
        <div className="fw-semibold fs-4 mb-3">Commission Rate</div>

        <HeaderOrange>
          Commission rates are applied to sales within specific categories to
          determine the earnings for sellers on our platform. The table below
          outlines the commission rates for each category. These rates are
          designed to reflect the costs associated with handling and promoting
          products within each category, ensuring fair compensation for sellers
          while maintaining competitive pricing for customers.
        </HeaderOrange>

        <DatatableComponent
          columns={columns}
          data={data}
          type={"yellow-bordered"}
        />
    </div>
  );
};

export default Commissions;